// hide unnecessary scrollbar on bar, line and combo chart after resizing
const hideHorizontalScrollbar = (chart) => {
    if (chart.scrollablePixelsX === 0 && chart.scrollingContainer) {
        chart.scrollingContainer.style["overflow-x"] = "hidden";
    } else if (chart.scrollingContainer) {
        chart.scrollingContainer.style["overflow-x"] = "auto";
    }
};
exports.hideHorizontalScrollbar = hideHorizontalScrollbar;
